<template>
  <div
    class="opacity-wrapper modalbox-wrapper"
    v-if="alias === stateCommon.modalBox.alias && getModalState"
  >
    <div class="modalbox">
      <div class="modalbox-content">
        <div class="modalbox-title">
          <slot name="modalTitle"></slot>
        </div>
        <div class="modalbox-body">
          <slot name="modalBody"></slot>
        </div>
        <div class="modalbox-footer">
          <slot name="modalFooter"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "ModalBox",
  props: {
    alias: {
      type: String,
      required: true,
    },
    head: {
      type: Boolean,
      default: true,
    },
    body: {
      type: Boolean,
      default: true,
    },
    foot: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({ stateCommon: "common" }),
    ...mapGetters(["getModalState", "getSecondModalState"]),
  },
};
</script>

<style lang="css" scoped>
.modalbox-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.modalbox {
  overflow: hidden;
  margin: 2rem;
  border-radius: var(--card-radius, 16px);
  border: 1px solid var(--modal-border);
  box-shadow: var(--shadow-lg);
  min-width: min(640px, calc(100vw - 1rem));
  max-width: 100%;
}
@media (max-width: 900px) {
  .modalbox { margin: 0.5rem; width: calc(100vw - 1rem); }
}
.modalbox-content {
  min-width: min(30rem, calc(100vw - 1rem));
  overflow-y: auto;
  background-color: var(--modal-bg);
  box-shadow: var(--shadow-lg);
  position: relative;
  max-height: 90vh;
}
.modalbox-title {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 28px;
  margin: 0;
  background-color: var(--modal-header-bg);
  color: var(--text-heading);
  font-size: 20px;
  font-weight: 650;
  letter-spacing: -0.01em;
  border-bottom-width: 1px;
  border-color: var(--modal-border);
  border-style: solid;
  line-height: 1.4;
  position: sticky;
  top: 0;
  right: 0;
  left: 0;
  height: 50px;
  z-index: 20;
  height: 100%;
}
.modalbox-body {
  overflow-y: scroll;
  padding: 2em;
  height: calc(80vh - 200px);
  color: var(--text-primary);
}
.modalbox-body .input-group:last-child {
  margin-bottom: 0;
}
.modalbox-body .form-col:last-child {
  margin-right: 0;
}
.modalbox-footer {
  padding: 16px 28px;
  background-color: var(--modal-footer-bg);
  border-top-width: 1px;
  border-color: var(--modal-border);
  border-style: solid;
  position: sticky;
  right: 0;
  bottom: 0;
  height: 50px;
  left: 0;
  z-index: 20;
  height: 100%;
}
#menu .modalbox-body,
#stock .modalbox-body,
#vendor .modalbox-body {
  height: 100% !important;
}
</style>
